import { HttpContextToken } from '@angular/common/http';

export const RETRY_COUNT = new HttpContextToken(() => 3);
export const CACHE_IT = new HttpContextToken<boolean>(() => false);
